import axios from 'axios';

import ApiGet from '../../../sections/mainheader/apiget';


let BASE_URL = null;

// Ensures API initialization
async function ensureApiInitialized() {
    if (!BASE_URL) {
        try {
            const apiUrl = await ApiGet();
            BASE_URL = apiUrl.replace('/api/', '/api');
             //  console.log('API URL initialized:', BASE_URL);
        } catch (error) {
            console.error('Failed to initialize API URL:', error);
            throw error; // Ensure proper handling
        }
    }
}


const GetApprovalHierarchySearchControls = async () => {
    await ensureApiInitialized();

    
    try {
        const response = await axios.get(`${BASE_URL}/ApprovalProcess/GetApprovalHierarchySearchControls`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const GetControlsForDefaultApprovalHierarchy = async () => {
    await ensureApiInitialized();

    try {
        const response = await axios.get(`${BASE_URL}/ApprovalProcess/GetControlsForDefaultApprovalHierarchy`);
        return response;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};

const SearchApprovalHierarchy = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.post(`${BASE_URL}/ApprovalProcess/SearchApprovalHierarchy`, payload);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const GetControlsForApprovalHierarchy = async () => {
    await ensureApiInitialized();

    try {
        const response = await axios.get(`${BASE_URL}/ApprovalProcess/GetControlsForApprovalHierarchy`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const getRoleWiseUser = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.get(`${BASE_URL}/ApprovalProcess/getRoleWiseUser/${payload}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const CreateApprovalHierarchy = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.post(`${BASE_URL}/ApprovalProcess/CreateApprovalHierarchy`, payload);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const GetApprovalHierarchyDetails = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.get(`${BASE_URL}/ApprovalProcess/GetApprovalHierarchyDetails/${payload}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const DeleteApprovalHierarchy = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.post(`${BASE_URL}/ApprovalProcess/DeleteApprovalHierarchy/${payload}`);
         //  console.log(response)
        return response.data;
        
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};
const UpdateApprovalHierarchy = async (payload) => {
    await ensureApiInitialized();

    try {
        const response = await axios.post(`${BASE_URL}/ApprovalProcess/UpdateApprovalHierarchy`, payload);
        return response.data;
    } catch (error) {
        console.error('Error fetching dependent controls: ', error);
        throw error;
    }
};



export default {
    GetApprovalHierarchySearchControls,
    SearchApprovalHierarchy,
    GetControlsForDefaultApprovalHierarchy,
    GetControlsForApprovalHierarchy,
    getRoleWiseUser,
    CreateApprovalHierarchy,
    GetApprovalHierarchyDetails,
    DeleteApprovalHierarchy,
    UpdateApprovalHierarchy
};
